<div class="footer">
  <p-calendar class="selected-month-datepicker"
    [(ngModel)]="selectedDate" 
    view="month" 
    dateFormat="MM yy" 
    (onSelect)="onCalendarSelect($event)"showClear=""
    [yearNavigator]="true" 
    [monthNavigator]="true" 
    [minDate]="minSelectableDate"
    [maxDate]="maxSelectableDate">
  </p-calendar>

  <!-- Timeline avec les boutons radio -->
  <div class="timeline">
    <!-- Ajouter un point de couleur si le mois sélectionné est avant la plage visible -->
    <div *ngIf="!isInVisibleRange(selectedMonth)" class="timeline-out-of-range"></div>

    <div *ngFor="let month of visibleMonths; let i = index" 
         class="timeline-item" 
         [ngClass]="{
           'selected': month.value === selectedMonth.value && month.year === selectedMonth.year,
           'future': isFutureMonth(month),
           'permanent-future': markPermanentFutureMonths(month),
           'last-december': isDecember(month) && i < visibleMonths.length - 1,
           'first-january': isJanuary(month) && i > 0,
           'past-month-selected': isSelectedMonthInPast() && isCurrentMonth(month)
         }"
         (click)="onTimelineItemClick(month)">
      <div class="month-name">{{ month.name.split(' ')[0] | translate }}</div>
      <label class="custom-radio">
        <input 
          type="radio" 
          name="month" 
          [value]="month" 
          [(ngModel)]="selectedMonth" 
          (change)="onMonthSelect({ value: month.value, year: month.year })" 
          [disabled]="isFutureMonth(month)">
        <span class="custom-radio-btn"></span>
      </label>
      <span class="year" *ngIf="month.value === 0 || month.value === 11">{{ month.year }}</span>
    </div>
  </div>
</div>
